import React, { useState, useRef, useEffect } from "react";
import { FaFileMedicalAlt, FaTimes, FaSave, FaRecycle } from "react-icons/fa";
import Cookies from "js-cookie";
import Logo from "../../images/logopdf.png";
import WatermarkLogo from "../../assets/afrafep.png";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import rodape from "../../images/rodape.png";
import api from "../../config/configApi";
import { toast } from "react-toastify";

// Importe as imagens PNG diretamente
import odPng from "../../images/Direito.png";
import oePng from "../../images/Esquerdo.png";

interface Professional {
  nmProfissional: string;
  nomePaciente: string;
  crm: string;
  cpf: string;
  idProfissional: string;
}

interface ReceituarioOftalmo {
  id: number;
  tipo: string;
  dtConsulta: string;
  hrConsulta: string;
  odEsfLong: string;
  odCilLong: string;
  odEixoLong: string;
  odPrismaLong: string;
  odBaseLong: string;
  oeEsfLong: string;
  oeCilLong: string;
  oeEixoLong: string;
  oePrismaLong: string;
  oeBaseLong: string;
  odEsfPerto: string;
  odCilPerto: string;
  odEixoPerto: string;
  odPrismaPerto: string;
  odBasePerto: string;
  oeEsfPerto: string;
  oeCilPerto: string;
  oeEixoPerto: string;
  oePrismaPerto: string;
  oeBasePerto: string;
  prescricao: string;
  criadoEm: string;
  editadoEm: string;
  profissional: {
    idProfissional: number;
    nmProfissional: string;
    CRM?: string;
    especialidade: {
      idEspecialidade?: number;
      dsEspecialidade: string;
      exibeQuestEpidem?: string;
      realizaProced?: string;
    };
  };
  paciente: {
    cdPaciente: number;
    nrCarteiraPlano: string;
    nmPaciente: string;
    dtNascimento: string;
    flSexo: string;
    cdStatus: number;
    nuCpf: string;
    nmEndereco: string;
    nuEndereco: number;
    nmComplEndereco: string;
    nmBairroEndereco: string;
    nmCidadeEndereco: string;
    nmUfEndereco: string;
    cdCepEndereco: string;
    cartaoSus: string;
  };
}

const ReceituarioOftalmoOn: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [receituariosExistentes, setReceituariosExistentes] = useState<
    ReceituarioOftalmo[]
  >([]);
  const [showReceituariosList, setShowReceituariosList] = useState(false);
  const [loadingReceituarios, setLoadingReceituarios] = useState(false);

  const [prescriptionData, setPrescriptionData] = useState({
    longe: {
      od: { esf: "", cil: "", eixo: "", prisma: "", base: "" },
      oe: { esf: "", cil: "", eixo: "", prisma: "", base: "" },
    },
    perto: {
      od: { esf: "", cil: "", eixo: "", prisma: "", base: "" },
      oe: { esf: "", cil: "", eixo: "", prisma: "", base: "" },
    },
    obs: "",
  });

  const professional: Professional = {
    nmProfissional: Cookies.get("nmProfissional") || "",
    nomePaciente: Cookies.get("Nome") || "",
    crm: Cookies.get("CRM") || "",
    cpf: Cookies.get("NuCPF") || "",
    idProfissional: (Cookies.get("idProfissional") || "").replace(/\D/g, ""),
  };

  // Função para buscar receituários oftalmológicos existentes do paciente
  const fetchReceituariosExistentes = async () => {
    setLoadingReceituarios(true);
    try {
      const token = sessionStorage.getItem("token");
      const cpf = professional.cpf;

      if (token && cpf) {
        const response = await api.get<ReceituarioOftalmo[]>(
          `/sisclinic/receituarios/cpf/${cpf}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // Filtrar apenas receituários oftalmológicos (tipo "OFTALMO") e ordenar por data mais recente
        const receituarios = response.data
          .filter((item) => item.tipo === "OFTALMO")
          .sort((a, b) => {
            const dateA = new Date(`${a.dtConsulta}T${a.hrConsulta}`);
            const dateB = new Date(`${b.dtConsulta}T${b.hrConsulta}`);
            return dateB.getTime() - dateA.getTime();
          });

        setReceituariosExistentes(receituarios);
      }
    } catch (error) {
      console.error(
        "Erro ao buscar receituários oftalmológicos existentes:",
        error
      );
      toast.error("Erro ao carregar receituários anteriores");
    } finally {
      setLoadingReceituarios(false);
    }
  };

  // Função para carregar um receituário existente no formulário
  const carregarReceituarioExistente = (receituario: ReceituarioOftalmo) => {
    setPrescriptionData({
      longe: {
        od: {
          esf: receituario.odEsfLong || "",
          cil: receituario.odCilLong || "",
          eixo: receituario.odEixoLong || "",
          prisma: receituario.odPrismaLong || "",
          base: receituario.odBaseLong || "",
        },
        oe: {
          esf: receituario.oeEsfLong || "",
          cil: receituario.oeCilLong || "",
          eixo: receituario.oeEixoLong || "",
          prisma: receituario.oePrismaLong || "",
          base: receituario.oeBaseLong || "",
        },
      },
      perto: {
        od: {
          esf: receituario.odEsfPerto || "",
          cil: receituario.odCilPerto || "",
          eixo: receituario.odEixoPerto || "",
          prisma: receituario.odPrismaPerto || "",
          base: receituario.odBasePerto || "",
        },
        oe: {
          esf: receituario.oeEsfPerto || "",
          cil: receituario.oeCilPerto || "",
          eixo: receituario.oeEixoPerto || "",
          prisma: receituario.oePrismaPerto || "",
          base: receituario.oeBasePerto || "",
        },
      },
      obs: receituario.prescricao || "",
    });
    setShowReceituariosList(false);
    toast.success("Receituário oftalmológico carregado com sucesso!");
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isModalOpen) setIsModalOpen(false);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isModalOpen]);

  const handleClose = () => {
    setIsModalOpen(false);
    setShowReceituariosList(false);
    // Limpar formulário ao fechar
    setPrescriptionData({
      longe: {
        od: { esf: "", cil: "", eixo: "", prisma: "", base: "" },
        oe: { esf: "", cil: "", eixo: "", prisma: "", base: "" },
      },
      perto: {
        od: { esf: "", cil: "", eixo: "", prisma: "", base: "" },
        oe: { esf: "", cil: "", eixo: "", prisma: "", base: "" },
      },
      obs: "",
    });
  };

  // Função para formatar data
  const formatDate = (dateString: string) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const handleGeneratePDF = async () => {
    setIsSubmitting(true);

    const agora = new Date();
    const dataHoraAtual = agora.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });
    const marginLeft = 40;
    const marginRight = 40;
    const marginTop = 20;
    const pageWidth =
      doc.internal.pageSize.getWidth() - marginLeft - marginRight;
    const pageHeight = doc.internal.pageSize.getHeight();
    const centerX = doc.internal.pageSize.getWidth() / 2;
    let currentY = marginTop;

    const addFooter = () => {
      const additionalInfo = [
        "Rua: Corálio Soares de Oliveira, nº 497, Centro, João Pessoa – PB, CEP 58.013-260.",
        "Telefone: 3533-5310 - www.afrafepsaude.com.br  @afrafepsaude",
        "CNPJ: 09.306.242/0001-82.",
      ];

      doc.setTextColor(105, 105, 105);
      let yOffset = pageHeight - 80;

      additionalInfo.forEach((line) => {
        const splitText = doc.splitTextToSize(line, 300);
        splitText.forEach((textLine: any) => {
          doc.text(textLine, 25, yOffset);
          yOffset += 10;
        });
        yOffset += 5;
      });

      const imgBase64 = rodape;
      const imgWidth = 180;
      const imgHeight = 80;
      const xOffsetImage = doc.internal.pageSize.width - imgWidth - 40;
      const yOffsetImage = pageHeight - imgHeight - 17;
      doc.addImage(
        imgBase64,
        "PNG",
        xOffsetImage,
        yOffsetImage,
        imgWidth,
        imgHeight
      );
    };

    const addHeader = async () => {
      const logoImg = new Image();
      logoImg.src = Logo;
      await new Promise<void>((resolve) => {
        logoImg.onload = () => {
          const imgWidth = doc.internal.pageSize.getWidth();
          const imgHeight = (logoImg.height * imgWidth) / logoImg.width;
          doc.addImage(Logo, "PNG", 0, 0, imgWidth, imgHeight);
          currentY = imgHeight + 30;
          resolve();
        };
        logoImg.onerror = (err) => {
          console.error("Erro ao carregar o logo:", err);
          resolve();
        };
      });
    };

    const addWatermark = async () => {
      await new Promise<void>((resolve) => {
        const watermarkImg = new Image();
        watermarkImg.src = WatermarkLogo;
        watermarkImg.onload = () => {
          const watermarkWidth = 350;
          const watermarkHeight =
            (watermarkImg.height * watermarkWidth) / watermarkImg.width;

          const canvas = document.createElement("canvas");
          canvas.width = watermarkImg.width;
          canvas.height = watermarkImg.height;
          const ctx = canvas.getContext("2d");

          if (ctx) {
            ctx.drawImage(watermarkImg, 0, 0);
            const imageData = ctx.getImageData(
              0,
              0,
              canvas.width,
              canvas.height
            );
            const data = imageData.data;

            for (let i = 0; i < data.length; i += 4) {
              if (data[i] > 150 && data[i + 1] < 80 && data[i + 2] < 80) {
                data[i] = 36;
                data[i + 1] = 99;
                data[i + 2] = 235;
                data[i + 3] = 30;
              } else if (data[i + 3] > 0) {
                data[i + 3] = 30;
              }
            }
            ctx.putImageData(imageData, 0, 0);

            doc.addImage(
              canvas.toDataURL("image/png"),
              "PNG",
              centerX - watermarkWidth / 2,
              pageHeight / 2 - watermarkHeight / 2,
              watermarkWidth,
              watermarkHeight,
              undefined,
              "FAST"
            );
          }
          resolve();
        };
        watermarkImg.onerror = (err) => {
          console.error("Erro ao carregar a imagem da marca d'água:", err);
          resolve();
        };
      });
    };

    const addContent = async () => {
      await addWatermark();
      await addHeader();

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      doc.text(`Nome: ${professional.nomePaciente}`, marginLeft, currentY);

      const protractorWidth = 250;
      const protractorHeight = 150;
      const protractorX1 = marginLeft + 10;
      const protractorX2 = centerX + 10;
      const protractorY = currentY;

      doc.addImage(
        odPng,
        "PNG",
        protractorX1,
        protractorY,
        protractorWidth,
        protractorHeight
      );
      doc.addImage(
        oePng,
        "PNG",
        protractorX2,
        protractorY,
        protractorWidth,
        protractorHeight
      );

      currentY += protractorHeight + 30;

      const tablesData = [
        { title: "LONGE", data: prescriptionData.longe },
        { title: "PERTO", data: prescriptionData.perto },
      ];

      for (const table of tablesData) {
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(table.title, marginLeft, currentY);
        currentY += 20;

        const bodyData = [
          [
            "OD",
            table.data.od.esf || "-",
            table.data.od.cil || "-",
            table.data.od.eixo || "-",
            table.data.od.prisma || "-",
            table.data.od.base || "-",
          ],
          [
            "OE",
            table.data.oe.esf || "-",
            table.data.oe.cil || "-",
            table.data.oe.eixo || "-",
            table.data.oe.prisma || "-",
            table.data.oe.base || "-",
          ],
        ];

        autoTable(doc, {
          head: [["Olho", "Esf.", "Cil.", "Eixo", "Prisma", "Base"]],
          body: bodyData,
          startY: currentY,
          theme: "grid",
          headStyles: {
            fillColor: [66, 139, 202],
            textColor: [255, 255, 255],
            fontStyle: "bold",
          },
          margin: { left: marginLeft, right: marginRight },
          styles: { fontSize: 10, halign: "center" },
          columnStyles: { 0: { cellWidth: "auto" } },
        });

        currentY = (doc as any).lastAutoTable.finalY + 20;
      }

      if (prescriptionData.obs) {
        if (currentY > pageHeight - 40) {
          doc.addPage();
          currentY = marginTop + 20;
        }
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text("OBS:", marginLeft, currentY);
        doc.setFont("helvetica", "normal");
        currentY += 15;
        const splitObs = doc.splitTextToSize(prescriptionData.obs, pageWidth);
        doc.text(splitObs, marginLeft, currentY);
        currentY += splitObs.length * 15 + 20;
      }

      if (currentY > pageHeight - 100) {
        doc.addPage();
        currentY = marginTop + 40;
      }

      doc.setFontSize(10);

      const lineLength = pageWidth / 3;
      doc.line(
        centerX - lineLength / 2,
        currentY + 90,
        centerX + lineLength / 2,
        currentY + 90
      );

      doc.text("Carimbo e Assinatura do Médico", centerX, currentY + 105, {
        align: "center",
      });
      doc.text(`${professional.nmProfissional}`, centerX, currentY + 120, {
        align: "center",
      });
      doc.text(`CRM: ${professional.crm}`, centerX, currentY + 135, {
        align: "center",
      });

      doc.text(
        `Data e hora de emissão: ${dataHoraAtual}`,
        centerX + 35,
        currentY + 55
      );

      addFooter();
    };

    currentY = marginTop;
    await addContent();

    const totalPages = (doc as any).internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(100);
      doc.text(`Página ${i} de ${totalPages}`, centerX, pageHeight - 20, {
        align: "center",
      });
    }

    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    setIsSubmitting(false);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    iframe.onload = function () {
      setTimeout(function () {
        iframe.contentWindow?.print();
      }, 500);
    };

    return pdfBlob;
  };

  const handleSaveOftalmo = async () => {
    const isLongeEmpty =
      !prescriptionData.longe.od.esf &&
      !prescriptionData.longe.od.cil &&
      !prescriptionData.longe.od.eixo &&
      !prescriptionData.longe.od.prisma &&
      !prescriptionData.longe.od.base &&
      !prescriptionData.longe.oe.esf &&
      !prescriptionData.longe.oe.cil &&
      !prescriptionData.longe.oe.eixo &&
      !prescriptionData.longe.oe.prisma &&
      !prescriptionData.longe.oe.base;

    const isPertoEmpty =
      !prescriptionData.perto.od.esf &&
      !prescriptionData.perto.od.cil &&
      !prescriptionData.perto.od.eixo &&
      !prescriptionData.perto.od.prisma &&
      !prescriptionData.perto.od.base &&
      !prescriptionData.perto.oe.esf &&
      !prescriptionData.perto.oe.cil &&
      !prescriptionData.perto.oe.eixo &&
      !prescriptionData.perto.oe.prisma &&
      !prescriptionData.perto.oe.base;

    if (isLongeEmpty && isPertoEmpty && !prescriptionData.obs) {
      toast.error(
        "Pelo menos um campo do receituário oftalmológico deve ser preenchido!",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return;
    }

    setIsSubmitting(true);

    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    const formattedTime = currentDate.toTimeString().substring(0, 5);

    const payload = {
      nuCpf: professional.cpf,
      idProfissional: professional.idProfissional,
      tipo: "OFTALMO",
      dtConsulta: formattedDate,
      hrConsulta: formattedTime,
      odEsfLong: prescriptionData.longe.od.esf || null,
      odCilLong: prescriptionData.longe.od.cil || null,
      odEixoLong: prescriptionData.longe.od.eixo || null,
      odPrismaLong: prescriptionData.longe.od.prisma || null,
      odBaseLong: prescriptionData.longe.od.base || null,
      oeEsfLong: prescriptionData.longe.oe.esf || null,
      oeCilLong: prescriptionData.longe.oe.cil || null,
      oeEixoLong: prescriptionData.longe.oe.eixo || null,
      oePrismaLong: prescriptionData.longe.oe.prisma || null,
      oeBaseLong: prescriptionData.longe.oe.base || null,
      odEsfPerto: prescriptionData.perto.od.esf || null,
      odCilPerto: prescriptionData.perto.od.cil || null,
      odEixoPerto: prescriptionData.perto.od.eixo || null,
      odPrismaPerto: prescriptionData.perto.od.prisma || null,
      odBasePerto: prescriptionData.perto.od.base || null,
      oeEsfPerto: prescriptionData.perto.oe.esf || null,
      oeCilPerto: prescriptionData.perto.oe.cil || null,
      oeEixoPerto: prescriptionData.perto.oe.eixo || null,
      oePrismaPerto: prescriptionData.perto.oe.prisma || null,
      oeBasePerto: prescriptionData.perto.oe.base || null,
      prescricao: prescriptionData.obs,
    };

    try {
      const response = await api.post("/receituarios", payload);

      if (response.status === 200 || response.status === 201) {
        toast.success("Receituário oftalmológico salvo com sucesso!");

        setTimeout(() => {
          handleGeneratePDF();

          setTimeout(() => {
            handleClose();
            setIsSubmitting(false);
          }, 3500);
        }, 1000);
      } else {
        throw new Error(`Erro ao salvar receituário: ${response.status}`);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Ocorreu um erro ao salvar o receituário oftalmológico");
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <button
        onClick={() => {
          setIsModalOpen(true);
          fetchReceituariosExistentes(); // Buscar receituários ao abrir o modal
        }}
        className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded flex items-center gap-2"
      >
        <FaFileMedicalAlt />
        Receituário Oftalmológico
      </button>

      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-50"
          onClick={handleClose}
        >
          <div
            className="bg-white rounded-lg w-full max-w-5xl max-h-[90vh] shadow-lg flex flex-col"
            ref={modalRef}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center border-b p-4 sticky top-0 bg-white z-10">
              <h2 className="text-xl font-bold">Receituário Oftalmológico</h2>
              <button
                onClick={handleClose}
                aria-label="Fechar modal"
                className="text-gray-700 hover:text-gray-900 transition"
              >
                <FaTimes size={20} />
              </button>
            </div>

            <div className="flex flex-1 overflow-hidden">
              {/* Lista de Receituários Oftalmológicos Existentes */}
              {showReceituariosList && (
                <div className="w-80 border-r bg-gray-50 overflow-y-auto">
                  <div className="p-4 border-b">
                    <h3 className="font-bold text-gray-700 mb-2">
                      Receituários Oftalmológicos Anteriores
                    </h3>
                    <button
                      onClick={() => setShowReceituariosList(false)}
                      className="text-sm text-blue-600 hover:text-blue-800"
                    >
                      ← Voltar ao formulário
                    </button>
                  </div>

                  {loadingReceituarios ? (
                    <div className="p-4 text-center">
                      <p className="text-gray-500">
                        Carregando receituários...
                      </p>
                    </div>
                  ) : receituariosExistentes.length > 0 ? (
                    <div className="p-2">
                      {receituariosExistentes.map((receituario) => (
                        <div
                          key={receituario.id}
                          className="p-3 mb-2 border rounded-lg bg-white hover:bg-blue-50 cursor-pointer transition-colors"
                          onClick={() =>
                            carregarReceituarioExistente(receituario)
                          }
                        >
                          <div className="font-semibold text-sm text-gray-800">
                            {formatDate(receituario.dtConsulta)}
                          </div>
                          <div className="text-xs text-blue-600 mt-1 font-medium">
                            Dr. {receituario.profissional.nmProfissional}
                          </div>
                          <div className="text-xs text-gray-500 truncate mt-1">
                            {receituario.prescricao
                              ? receituario.prescricao.substring(0, 60) + "..."
                              : "Sem observações"}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="p-4 text-center">
                      <p className="text-gray-500">
                        Nenhum receituário oftalmológico anterior encontrado
                      </p>
                    </div>
                  )}
                </div>
              )}

              {/* Conteúdo Principal */}
              <div
                className={`flex-1 overflow-y-auto ${
                  showReceituariosList ? "" : "w-full"
                }`}
              >
                <div className="p-8 text-sm text-black bg-white">
                  {/* Cabeçalho com Botão Reutilizar */}
                  <div className="flex justify-between items-start mb-6">
                    <div className="relative flex-1"></div>

                    {/* Botão Reutilizar Receituário - só aparece quando NÃO está mostrando a lista */}
                    {!showReceituariosList &&
                      receituariosExistentes.length > 0 && (
                        <div className="flex-shrink-0 ml-4">
                          <button
                            onClick={() => setShowReceituariosList(true)}
                            className="bg-green-600 hover:bg-green-700 text-white py-2 px-3 rounded flex items-center gap-2 text-sm"
                          >
                            <FaRecycle />
                            Reutilizar Receituário
                          </button>
                        </div>
                      )}
                  </div>

                  <div className="flex flex-col md:flex-row justify-between mb-4">
                    <div className="w-full md:w-1/2 md:pr-4">
                      <p>
                        <strong>Nome:</strong> {professional.nomePaciente}
                      </p>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4 mb-6">
                    <div className="flex justify-center items-center">
                      <div className="border border-gray-300 w-70 h-30 flex items-center justify-center">
                        <img
                          src="/od.svg"
                          alt="Olho Direito"
                          className="max-w-full max-h-full"
                        />
                      </div>
                    </div>
                    <div className="flex justify-center items-center">
                      <div className="border border-gray-300 w-70 h-30 flex items-center justify-center">
                        <img
                          src="/oe.svg"
                          alt="Olho Esquerdo"
                          className="max-w-full max-h-full"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Longe section */}
                  <div className="mb-4">
                    <h3 className="font-bold">LONGE</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="border p-2 rounded">
                        <h4 className="font-bold text-center mb-2">OD</h4>
                        <div className="grid grid-cols-5 gap-2 items-center">
                          <div className="text-center text-xs font-semibold">
                            Esf.
                          </div>
                          <div className="text-center text-xs font-semibold">
                            Cil.
                          </div>
                          <div className="text-center text-xs font-semibold">
                            Eixo
                          </div>
                          <div className="text-center text-xs font-semibold">
                            Prisma
                          </div>
                          <div className="text-center text-xs font-semibold">
                            Base
                          </div>
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.longe.od.esf}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                longe: {
                                  ...prev.longe,
                                  od: { ...prev.longe.od, esf: e.target.value },
                                },
                              }))
                            }
                          />
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.longe.od.cil}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                longe: {
                                  ...prev.longe,
                                  od: { ...prev.longe.od, cil: e.target.value },
                                },
                              }))
                            }
                          />
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.longe.od.eixo}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                longe: {
                                  ...prev.longe,
                                  od: {
                                    ...prev.longe.od,
                                    eixo: e.target.value,
                                  },
                                },
                              }))
                            }
                          />
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.longe.od.prisma}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                longe: {
                                  ...prev.longe,
                                  od: {
                                    ...prev.longe.od,
                                    prisma: e.target.value,
                                  },
                                },
                              }))
                            }
                          />
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.longe.od.base}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                longe: {
                                  ...prev.longe,
                                  od: {
                                    ...prev.longe.od,
                                    base: e.target.value,
                                  },
                                },
                              }))
                            }
                          />
                        </div>
                      </div>
                      <div className="border p-2 rounded">
                        <h4 className="font-bold text-center mb-2">OE</h4>
                        <div className="grid grid-cols-5 gap-2 items-center">
                          <div className="text-center text-xs font-semibold">
                            Esf.
                          </div>
                          <div className="text-center text-xs font-semibold">
                            Cil.
                          </div>
                          <div className="text-center text-xs font-semibold">
                            Eixo
                          </div>
                          <div className="text-center text-xs font-semibold">
                            Prisma
                          </div>
                          <div className="text-center text-xs font-semibold">
                            Base
                          </div>
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.longe.oe.esf}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                longe: {
                                  ...prev.longe,
                                  oe: { ...prev.longe.oe, esf: e.target.value },
                                },
                              }))
                            }
                          />
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.longe.oe.cil}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                longe: {
                                  ...prev.longe,
                                  oe: { ...prev.longe.oe, cil: e.target.value },
                                },
                              }))
                            }
                          />
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.longe.oe.eixo}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                longe: {
                                  ...prev.longe,
                                  oe: {
                                    ...prev.longe.oe,
                                    eixo: e.target.value,
                                  },
                                },
                              }))
                            }
                          />
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.longe.oe.prisma}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                longe: {
                                  ...prev.longe,
                                  oe: {
                                    ...prev.longe.oe,
                                    prisma: e.target.value,
                                  },
                                },
                              }))
                            }
                          />
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.longe.oe.base}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                longe: {
                                  ...prev.longe,
                                  oe: {
                                    ...prev.longe.oe,
                                    base: e.target.value,
                                  },
                                },
                              }))
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Perto section */}
                  <div className="mb-4">
                    <h3 className="font-bold">PERTO</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="border p-2 rounded">
                        <h4 className="font-bold text-center mb-2">OD</h4>
                        <div className="grid grid-cols-5 gap-2 items-center">
                          <div className="text-center text-xs font-semibold">
                            Esf.
                          </div>
                          <div className="text-center text-xs font-semibold">
                            Cil.
                          </div>
                          <div className="text-center text-xs font-semibold">
                            Eixo
                          </div>
                          <div className="text-center text-xs font-semibold">
                            Prisma
                          </div>
                          <div className="text-center text-xs font-semibold">
                            Base
                          </div>
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.perto.od.esf}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                perto: {
                                  ...prev.perto,
                                  od: { ...prev.perto.od, esf: e.target.value },
                                },
                              }))
                            }
                          />
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.perto.od.cil}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                perto: {
                                  ...prev.perto,
                                  od: { ...prev.perto.od, cil: e.target.value },
                                },
                              }))
                            }
                          />
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.perto.od.eixo}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                perto: {
                                  ...prev.perto,
                                  od: {
                                    ...prev.perto.od,
                                    eixo: e.target.value,
                                  },
                                },
                              }))
                            }
                          />
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.perto.od.prisma}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                perto: {
                                  ...prev.perto,
                                  od: {
                                    ...prev.perto.od,
                                    prisma: e.target.value,
                                  },
                                },
                              }))
                            }
                          />
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.perto.od.base}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                perto: {
                                  ...prev.perto,
                                  od: {
                                    ...prev.perto.od,
                                    base: e.target.value,
                                  },
                                },
                              }))
                            }
                          />
                        </div>
                      </div>
                      <div className="border p-2 rounded">
                        <h4 className="font-bold text-center mb-2">OE</h4>
                        <div className="grid grid-cols-5 gap-2 items-center">
                          <div className="text-center text-xs font-semibold">
                            Esf.
                          </div>
                          <div className="text-center text-xs font-semibold">
                            Cil.
                          </div>
                          <div className="text-center text-xs font-semibold">
                            Eixo
                          </div>
                          <div className="text-center text-xs font-semibold">
                            Prisma
                          </div>
                          <div className="text-center text-xs font-semibold">
                            Base
                          </div>
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.perto.oe.esf}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                perto: {
                                  ...prev.perto,
                                  oe: { ...prev.perto.oe, esf: e.target.value },
                                },
                              }))
                            }
                          />
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.perto.oe.cil}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                perto: {
                                  ...prev.perto,
                                  oe: { ...prev.perto.oe, cil: e.target.value },
                                },
                              }))
                            }
                          />
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.perto.oe.eixo}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                perto: {
                                  ...prev.perto,
                                  oe: {
                                    ...prev.perto.oe,
                                    eixo: e.target.value,
                                  },
                                },
                              }))
                            }
                          />
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.perto.oe.prisma}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                perto: {
                                  ...prev.perto,
                                  oe: {
                                    ...prev.perto.oe,
                                    prisma: e.target.value,
                                  },
                                },
                              }))
                            }
                          />
                          <input
                            type="text"
                            className="border w-full text-center p-1 rounded"
                            value={prescriptionData.perto.oe.base}
                            onChange={(e) =>
                              setPrescriptionData((prev) => ({
                                ...prev,
                                perto: {
                                  ...prev.perto,
                                  oe: {
                                    ...prev.perto.oe,
                                    base: e.target.value,
                                  },
                                },
                              }))
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Observations */}
                  <div className="mb-4">
                    <p className="font-bold">OBS:</p>
                    <textarea
                      className="border w-full h-24 p-2 rounded"
                      value={prescriptionData.obs}
                      onChange={(e) =>
                        setPrescriptionData({
                          ...prescriptionData,
                          obs: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                {/* Botões de Ação */}
                <div className="border-t p-4 flex justify-end gap-3 bg-gray-50 mt-auto">
                  <button
                    onClick={() =>
                      setShowReceituariosList(!showReceituariosList)
                    }
                    className="bg-gray-900 hover:bg-gray-800 text-white py-2 px-4 rounded flex items-center gap-2"
                  >
                    <FaRecycle />
                    {showReceituariosList
                      ? "Voltar ao Formulário"
                      : "Ver Receituários Anteriores"}
                  </button>

                  <button
                    onClick={handleSaveOftalmo}
                    disabled={isSubmitting}
                    className={`bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded flex items-center gap-2 ${
                      isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  >
                    <FaSave />
                    {isSubmitting
                      ? "Salvando, Abrindo PDF..."
                      : "Salvar e Gerar PDF"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReceituarioOftalmoOn;
